import axios from 'axios';
import { baseURL } from '../settings';

const BLOG_API_BASE = `${baseURL}api/ui/blog-post`;

// Get all blog posts (admin) - with pagination
export const getAllBlogPosts = (page = 0, size = 10) =>
  axios
    .get(`${BLOG_API_BASE}/paginated`, {
      params: { page, size }
    })
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching blog posts:', error);
      throw error;
    });

// Get published blog posts (public) - with pagination
export const getPublishedBlogPosts = (page = 0, size = 10) =>
  axios
    .get(`${BLOG_API_BASE}/published`, {
      params: { page, size }
    })
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching published blog posts:', error);
      throw error;
    });

// Get blog post by ID
export const getBlogPostById = (id) =>
  axios
    .get(`${BLOG_API_BASE}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching blog post:', error);
      throw error;
    });

// Get blog post by slug
export const getBlogPostBySlug = (slug) =>
  axios
    .get(`${BLOG_API_BASE}/slug/${slug}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching blog post by slug:', error);
      throw error;
    });

// Create blog post
export const createBlogPost = (blogData) =>
  axios({
    url: `${BLOG_API_BASE}`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    data: blogData
  })
    .then(res => res.data)
    .catch(error => {
      console.error('Error creating blog post:', error);
      throw error;
    });

// Update blog post
export const updateBlogPost = (blogData, version) =>
  axios({
    url: `${BLOG_API_BASE}`,
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'If-Match': version.toString()
    },
    data: blogData
  })
    .then(res => res.data)
    .catch(error => {
      console.error('Error updating blog post:', error);
      throw error;
    });

// Delete blog post
export const deleteBlogPost = (id) =>
  axios
    .delete(`${BLOG_API_BASE}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Error deleting blog post:', error);
      throw error;
    });

// Publish blog post
export const publishBlogPost = (id) =>
  axios
    .post(`${BLOG_API_BASE}/${id}/publish`)
    .then(res => res.data)
    .catch(error => {
      console.error('Error publishing blog post:', error);
      throw error;
    });

// Unpublish blog post
export const unpublishBlogPost = (id) =>
  axios
    .post(`${BLOG_API_BASE}/${id}/unpublish`)
    .then(res => res.data)
    .catch(error => {
      console.error('Error unpublishing blog post:', error);
      throw error;
    });

// Note: Image upload is handled directly by Cloudinary widget
// The backend endpoint /upload-image is kept for backward compatibility if needed

// Search blog posts
export const searchBlogPosts = (keyword) =>
  axios
    .get(`${BLOG_API_BASE}/search`, {
      params: { keyword }
    })
    .then(res => res.data)
    .catch(error => {
      console.error('Error searching blog posts:', error);
      throw error;
    });

// Get posts by category
export const getBlogPostsByCategory = (category) =>
  axios
    .get(`${BLOG_API_BASE}/category/${category}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching posts by category:', error);
      throw error;
    });

// Get posts by tag
export const getBlogPostsByTag = (tag) =>
  axios
    .get(`${BLOG_API_BASE}/tag/${tag}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching posts by tag:', error);
      throw error;
    });

// Validate slug
export const validateSlug = (slug, excludeId = null) =>
  axios
    .get(`${BLOG_API_BASE}/validate-slug`, {
      params: { slug, excludeId }
    })
    .then(res => res.data)
    .catch(error => {
      console.error('Error validating slug:', error);
      throw error;
    });
